<template>
  <div class="animated fadeInUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} Segment</div>
      <div>
        <router-link
          class="btn-blue"
          :to="{ name: 'Edit Segment',params:{segment_id:sid} }"
        >{{ $tc("edit") }}</router-link>
        <router-link class="btn-blue" :to="{name:'Segments'}">Segments {{ $tc("list") }}</router-link>
      </div>
    </div>

    <div class="white-wrapper pb-0 overflow-hidden">
      <div class="row">
        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <label>Segment Name - {{ segment_name }}</label>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <label>Segment Type - {{ segment_type }}</label>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 mb-4 align-self-center">
          <div class="d-flex align-items-center">
            <label v-if="segment_is_active == 'Y'">Status - Active</label>
            <label v-else>Status - Inactive</label>
          </div>
        </div>

        <div class="col-12 border-top p-4 bg-light">
          <div class="row">
            <div class="col-8 mb-4 align-self-center">
              <h5 class="mb-0">Customer List</h5>
            </div>
            <!-- <div class="card" v-for="(post,i) in filteredList" :key="i">{{post.cust_email}}</div> -->
            <div class="col-12">
              <table class="table">
                <thead>
                  <tr>
                    <th>Customer ID</th>
                    <th>Customer Name</th>
                    <th>Mobile Number</th>
                    <th>Email Address</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody v-if="customerlist.length == 0">
                  <tr>
                    <td colspan="4">
                      <h3 class="text-center">{{ 'No records found' }}</h3>
                    </td>
                  </tr>
                </tbody>
                <tbody v-for="(customer, customerIndex) in selected_customers" :key="customerIndex">
                  <tr>
                    <td>{{customer.cust_id}}</td>
                    <td>{{customer.first_name?customer.first_name:"-"}} {{customer.last_name}}</td>
                    <td>{{customer.cust_mobile?customer.cust_mobile:-""}}</td>
                    <td>{{customer.cust_email?customer.cust_email:"-"}}</td>
                    <td class="text-center">
                      <b-form-checkbox
                        style="pointer-events: none;"
                        class="j-checkbox"
                        disabled
                        :value="customer.cust_id"
                        v-model="customer.cust_id"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mt-4">
       <multiselect
                v-model="selected_filter"
                placeholder="Select Filter"
                track-by="filter_name"
                label="filter_name"
                :options="filters"
              ></multiselect>
      <div class="col-3 input-material">
        <input type="text" v-model="filter_data" v-if="selected_filter" />
      </div>
      <button class="btn-blue" @click="fetchCustomer" variant="default">Fetch</button>
    </div>-->
  </div>
</template>

<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import moment from "moment";
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      segments: [],
      selected_segment: null,
      customerlist: [],
      selected_customers: [],

      btenable: false,
      sid: "",
      filters: [
        { filter_name: "Email", filter_value: "cust_email" },
        { filter_name: "Phone Number", filter_value: "cust_mobile" }
      ],
      selected_filter: null,
      filter_data: null,
      segment_name: "",
      segment_type: "",
      segment_is_active: true,
      search: "",
      removeCustomerId: []
    };
  },

  computed: {
    filteredList() {
      if (this.customerlist.length > 0) {
        return this.customerlist.filter(post => {
          if (post.cust_email === null) return;
          else {
            return post.cust_email
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
        });
      }
    }
  },
  // watch: {
  //   search: function(newVal) {
  //     if (newVal) {
  //       console.log("newVal :", newVal);
  //     }
  //   }
  // },
  beforeMount() {
    this.getSingleSegment();
  },
  mounted() {
    this.getSegments();
    this.getCustomers();
  },
  methods: {
    checker(event, checkbox) {
      console.log("event :", event);
      console.log("checkbox :", checkbox);
      if (event === null && checkbox !== null) {
        this.removeCustomerId.push(checkbox);
        console.log("removeCustomerId :", this.removeCustomerId);
      }
    },
    getSingleSegment() {
      const { segment_id } = this.$route.params;
      this.sid = segment_id;
      MarketingAutomation.GetSingleSegment({
        segment_id: segment_id
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            // console.log("data.Records :", data.Records);
            this.segment_name = data.Records[0].segment_name;
            this.segment_type = data.Records[0].segment_type;
            for (let i in data.Records) {
              this.selected_customers.push(
                data.Records[i]
                // first_name: data.Records[i].first_name
              );
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    fetchCustomer() {
      // if (this.selected_filter && this.filter_data) {
      let payload = {
        filter_name: this.selected_filter
          ? this.selected_filter.filter_value
          : "-",
        filter_data: this.filter_data ? this.filter_data : "-"
      };
      MarketingAutomation.GetCustomers(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.customerlist = data.Records;

            console.log("this.customerlist :", this.customerlist);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
      // } else {
      //   this.$toasted.show("Please enter details");
      // }
    },
    getSegments() {
      MarketingAutomation.getSegments()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.segments = data.Records;

            console.log("this.segments :", this.segments);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomers();
      } else {
        this.currentPage = event;
        this.getCustomers();
      }
    },
    getCustomers() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage
      };
      MarketingAutomation.GetCustomers(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.customerlist = data.Records;

            this.rows = data.totalRows;

            console.log("this.customerlist :", this.customerlist);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onFinalSubmit(flag) {
      const { segment_id } = this.$route.params;

      //   this.submitted = true;
      //   this.$validator.validate().then(valid => {
      if (
        this.selected_customers.length > 0 &&
        this.segment_name !== "" &&
        this.segment_type !== ""
      ) {
        // if (valid) {
        //   this.btenable = true;
        let payload = {
          segment_id: segment_id,
          segment_name: this.segment_name,
          segment_type: this.segment_type,
          customerId: this.selected_customers,
          segment_is_active: this.segment_is_active,
          removeCustomerId: this.removeCustomerId
        };
        MarketingAutomation.UpdateSegment(payload)
          .then(response => {
            //   this.btenable = false;
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              // if (flag) {
              this.$router.push({
                name: "Segments"
              });
              // } else {
              //   this.submitted = false;
              // }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
        // }
        //   });
      } else {
        this.$toasted.show("Enter all details");
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/Segments/viewSegment.vue